import GlassFrogModel from 'legacy/GlassFrog/GlassFrogModel'

const Vote = GlassFrogModel.extend({}, {
  resourceName: 'votes',
})

export default Vote
